export default "__VITE_ASSET__a8e42b10__"